const DEFAULT_ASSISTANT_NAMES = new Set(["Addy AI", "Addy AI v2"]);

export const getWhiteLabeledAssistantName = (assistant, assistantName) => {
  const originalName =
    assistant?.appName || assistant?.name || (typeof assistant === "string" ? assistant : "");
  const brandedName = typeof assistantName === "string" ? assistantName.trim() : "";

  if (!brandedName || !DEFAULT_ASSISTANT_NAMES.has(originalName)) {
    return originalName;
  }

  return originalName === "Addy AI v2" ? `${brandedName} v2` : brandedName;
};

export const getOrganizationWhiteLabelAssistantName = (organization) => {
  const settings = organization?.whiteLabelSettings || {};
  const assistantName =
    typeof settings.assistantName === "string" ? settings.assistantName.trim() : "";
  const appName = typeof settings.appName === "string" ? settings.appName.trim() : "";

  return assistantName || appName;
};

export const getOrganizationWhiteLabelLogoUrl = (organization) => {
  const settings = organization?.whiteLabelSettings || {};
  const logoUrl = typeof settings.logoUrl === "string" ? settings.logoUrl.trim() : "";

  return resolveSidebarLogoUrl(logoUrl);
};

// The square "Organization Image" fits the round message avatar; the white-label logo is often a wide wordmark.
export const getOrganizationAvatarUrl = (organization) => {
  const imageUrl = resolveSidebarLogoUrl(organization?.imageUrl);
  if (imageUrl) return imageUrl;

  return getOrganizationWhiteLabelLogoUrl(organization);
};

export const resolveSidebarLogoUrl = (logoUrl) => {
  const normalizedLogoUrl = typeof logoUrl === "string" ? logoUrl.trim() : "";
  if (!normalizedLogoUrl) return "";

  return normalizedLogoUrl.startsWith("/assets/") ? "" : normalizedLogoUrl;
};

export const truncateAssistantName = (name, maxLength = 17) => {
  if (!name) return "";
  return name.length > maxLength ? `${name.substring(0, maxLength - 1)}...` : name;
};
